import {createStore} from 'zustand';

interface DashboardArchiveFilterStore {
  archived: boolean;
  setArchived: (archived: boolean) => void;
}

export const createDashboardArchiveFilterStore = () =>
  createStore<DashboardArchiveFilterStore>((set) => ({
    archived: false,
    setArchived: (archived) => set({archived}),
  }));

interface ServiceRequestsArchiveFilterStore {
  archived: boolean;
  setArchived: (archived: boolean) => void;
}

export const createServiceRequestsArchiveFilterStore = () =>
  createStore<ServiceRequestsArchiveFilterStore>((set) => ({
    archived: false,
    setArchived: (archived) => set({archived}),
  }));
